/**
 * Task Summary Banner Component
 * Displays pending, completed, and dismissed task counts
 *
 * @module pages/tasks/components/TaskSummaryBanner
 */

import type { TaskSummaryBannerProps } from '../types';

export function TaskSummaryBanner({ pendingCount, completedTodayCount, dismissedCount }: TaskSummaryBannerProps) {
  return (
    <div className="flex items-center gap-6 text-sm">
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-amber-500" />
        <span className="text-foreground font-medium">{pendingCount}</span>
        <span className="text-muted">pending</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-success" />
        <span className="text-foreground font-medium">{completedTodayCount}</span>
        <span className="text-muted">completed today</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-muted" />
        <span className="text-foreground font-medium">{dismissedCount}</span>
        <span className="text-muted">dismissed</span>
      </div>
    </div>
  );
}
